import { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { Button, SelectInput, required, useNotify, useRecordContext, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import { doctoralSeatLabel } from "../../seatLabel";
import { useNotifyError } from "utils/useNotifyError";

const AddSeatDialog = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const notifyError = useNotifyError();
  const refresh = useRefresh();
  const [options, setOptions] = useState([]);

  if (!record?.id) return null;

  const loadOptions = async () => {
    try {
      const { data } = await dataProvider.customRequest(
        doctoralRequests.availableCandidacySeats(record.id),
        null,
        "GET",
      );

      setOptions((data ?? []).map(s => ({ id: s.doctoralSeatId, name: doctoralSeatLabel(s) })));
    } catch (err) {
      notifyError(err);
      setOptions([]);
      return false;
    }
  };

  const handleConfirm = async ({ doctoralSeatId }) => {
    await dataProvider.customRequest(doctoralRequests.addCandidacySeat(record.id), { doctoralSeatId }, "POST");
    notify("Мястото е добавено", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Добавяне на място"
      saveTitle="Добави"
      onOpen={loadOptions}
      onConfirm={handleConfirm}
      triggerButton={
        <Button
          label="Добави място"
          variant="contained"
          startIcon={<AddIcon />}
        />
      }
    >
      <SelectInput
        source="doctoralSeatId"
        label="Място"
        choices={options}
        validate={[required()]}
        fullWidth
      />
    </FormModal>
  );
};

export default AddSeatDialog;
